// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

const Search: React.FunctionComponent<any> = (props) => {
    return (
        <SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
            <g
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                transform="translate(1 1)"
            >
                <circle cx="5.158" cy="5.158" r="5.158" />
                <path d="M13.263 13.263L9.211 9.211" />
            </g>
        </SvgIcon>
    );
};

// separate export statement so function name shows up in React DevTools
export { Search };
